// State tilegram positions (col, row) — geographic approximation
export type StateInfo = {
  code: string;
  name: string;
  slug: string;
  col: number;
  row: number;
  cities: string[];
};

export const STATES_DATA: StateInfo[] = [
  {
    code: "AK",
    name: "Alaska",
    slug: "alaska",
    col: 0,
    row: 6,
    cities: ["Anchorage", "Fairbanks", "Juneau"],
  },
  {
    code: "ME",
    name: "Maine",
    slug: "maine",
    col: 11,
    row: 0,
    cities: ["Portland", "Bangor", "Augusta"],
  },
  {
    code: "VT",
    name: "Vermont",
    slug: "vermont",
    col: 10,
    row: 1,
    cities: ["Burlington", "Montpelier", "Rutland"],
  },
  {
    code: "NH",
    name: "New Hampshire",
    slug: "new-hampshire",
    col: 11,
    row: 1,
    cities: ["Manchester", "Nashua", "Concord"],
  },
  {
    code: "WA",
    name: "Washington",
    slug: "washington",
    col: 1,
    row: 1,
    cities: ["Seattle", "Spokane", "Tacoma"],
  },
  {
    code: "MT",
    name: "Montana",
    slug: "montana",
    col: 3,
    row: 1,
    cities: ["Billings", "Missoula", "Bozeman"],
  },
  {
    code: "ND",
    name: "North Dakota",
    slug: "north-dakota",
    col: 5,
    row: 1,
    cities: ["Fargo", "Bismarck", "Grand Forks"],
  },
  {
    code: "MN",
    name: "Minnesota",
    slug: "minnesota",
    col: 6,
    row: 1,
    cities: ["Minneapolis", "Saint Paul", "Rochester"],
  },
  {
    code: "WI",
    name: "Wisconsin",
    slug: "wisconsin",
    col: 7,
    row: 1,
    cities: ["Milwaukee", "Madison", "Green Bay"],
  },
  {
    code: "MI",
    name: "Michigan",
    slug: "michigan",
    col: 8,
    row: 1,
    cities: ["Detroit", "Grand Rapids", "Lansing"],
  },
  {
    code: "NY",
    name: "New York",
    slug: "new-york",
    col: 10,
    row: 2,
    cities: ["New York City", "Buffalo", "Albany", "Rochester"],
  },
  {
    code: "MA",
    name: "Massachusetts",
    slug: "massachusetts",
    col: 11,
    row: 2,
    cities: ["Boston", "Worcester", "Springfield"],
  },
  {
    code: "OR",
    name: "Oregon",
    slug: "oregon",
    col: 1,
    row: 2,
    cities: ["Portland", "Salem", "Eugene"],
  },
  {
    code: "ID",
    name: "Idaho",
    slug: "idaho",
    col: 2,
    row: 2,
    cities: ["Boise", "Idaho Falls", "Nampa"],
  },
  {
    code: "WY",
    name: "Wyoming",
    slug: "wyoming",
    col: 3,
    row: 2,
    cities: ["Cheyenne", "Casper", "Jackson"],
  },
  {
    code: "SD",
    name: "South Dakota",
    slug: "south-dakota",
    col: 5,
    row: 2,
    cities: ["Sioux Falls", "Rapid City", "Pierre"],
  },
  {
    code: "IA",
    name: "Iowa",
    slug: "iowa",
    col: 6,
    row: 2,
    cities: ["Des Moines", "Cedar Rapids", "Davenport"],
  },
  {
    code: "IL",
    name: "Illinois",
    slug: "illinois",
    col: 7,
    row: 2,
    cities: ["Chicago", "Springfield", "Naperville"],
  },
  {
    code: "IN",
    name: "Indiana",
    slug: "indiana",
    col: 8,
    row: 2,
    cities: ["Indianapolis", "Fort Wayne", "Evansville"],
  },
  {
    code: "OH",
    name: "Ohio",
    slug: "ohio",
    col: 9,
    row: 2,
    cities: ["Columbus", "Cleveland", "Cincinnati"],
  },
  {
    code: "PA",
    name: "Pennsylvania",
    slug: "pennsylvania",
    col: 10,
    row: 3,
    cities: ["Philadelphia", "Pittsburgh", "Harrisburg"],
  },
  {
    code: "NJ",
    name: "New Jersey",
    slug: "new-jersey",
    col: 11,
    row: 3,
    cities: ["Newark", "Jersey City", "Trenton"],
  },
  {
    code: "CT",
    name: "Connecticut",
    slug: "connecticut",
    col: 12,
    row: 2,
    cities: ["Bridgeport", "Hartford", "New Haven"],
  },
  {
    code: "RI",
    name: "Rhode Island",
    slug: "rhode-island",
    col: 12,
    row: 3,
    cities: ["Providence", "Warwick", "Cranston"],
  },
  {
    code: "CA",
    name: "California",
    slug: "california",
    col: 1,
    row: 3,
    cities: ["Los Angeles", "San Francisco", "San Diego", "Sacramento"],
  },
  {
    code: "NV",
    name: "Nevada",
    slug: "nevada",
    col: 2,
    row: 3,
    cities: ["Las Vegas", "Reno", "Henderson"],
  },
  {
    code: "UT",
    name: "Utah",
    slug: "utah",
    col: 3,
    row: 3,
    cities: ["Salt Lake City", "Provo", "Ogden"],
  },
  {
    code: "CO",
    name: "Colorado",
    slug: "colorado",
    col: 4,
    row: 3,
    cities: ["Denver", "Colorado Springs", "Boulder"],
  },
  {
    code: "NE",
    name: "Nebraska",
    slug: "nebraska",
    col: 5,
    row: 3,
    cities: ["Omaha", "Lincoln", "Bellevue"],
  },
  {
    code: "MO",
    name: "Missouri",
    slug: "missouri",
    col: 6,
    row: 3,
    cities: ["Kansas City", "St. Louis", "Springfield"],
  },
  {
    code: "KY",
    name: "Kentucky",
    slug: "kentucky",
    col: 8,
    row: 3,
    cities: ["Louisville", "Lexington", "Bowling Green"],
  },
  {
    code: "WV",
    name: "West Virginia",
    slug: "west-virginia",
    col: 9,
    row: 3,
    cities: ["Charleston", "Huntington", "Morgantown"],
  },
  {
    code: "VA",
    name: "Virginia",
    slug: "virginia",
    col: 10,
    row: 4,
    cities: ["Virginia Beach", "Richmond", "Norfolk"],
  },
  {
    code: "MD",
    name: "Maryland",
    slug: "maryland",
    col: 11,
    row: 4,
    cities: ["Baltimore", "Annapolis", "Rockville"],
  },
  {
    code: "DE",
    name: "Delaware",
    slug: "delaware",
    col: 12,
    row: 4,
    cities: ["Wilmington", "Dover", "Newark"],
  },
  {
    code: "AZ",
    name: "Arizona",
    slug: "arizona",
    col: 2,
    row: 4,
    cities: ["Phoenix", "Tucson", "Mesa"],
  },
  {
    code: "NM",
    name: "New Mexico",
    slug: "new-mexico",
    col: 3,
    row: 4,
    cities: ["Albuquerque", "Santa Fe", "Las Cruces"],
  },
  {
    code: "KS",
    name: "Kansas",
    slug: "kansas",
    col: 5,
    row: 4,
    cities: ["Wichita", "Overland Park", "Topeka"],
  },
  {
    code: "OK",
    name: "Oklahoma",
    slug: "oklahoma",
    col: 5,
    row: 5,
    cities: ["Oklahoma City", "Tulsa", "Norman"],
  },
  {
    code: "AR",
    name: "Arkansas",
    slug: "arkansas",
    col: 6,
    row: 4,
    cities: ["Little Rock", "Fayetteville", "Fort Smith"],
  },
  {
    code: "TN",
    name: "Tennessee",
    slug: "tennessee",
    col: 7,
    row: 4,
    cities: ["Nashville", "Memphis", "Knoxville"],
  },
  {
    code: "NC",
    name: "North Carolina",
    slug: "north-carolina",
    col: 9,
    row: 4,
    cities: ["Charlotte", "Raleigh", "Greensboro"],
  },
  {
    code: "SC",
    name: "South Carolina",
    slug: "south-carolina",
    col: 9,
    row: 5,
    cities: ["Charleston", "Columbia", "Greenville"],
  },
  {
    code: "TX",
    name: "Texas",
    slug: "texas",
    col: 5,
    row: 6,
    cities: ["Houston", "Dallas", "Austin", "San Antonio"],
  },
  {
    code: "LA",
    name: "Louisiana",
    slug: "louisiana",
    col: 6,
    row: 5,
    cities: ["New Orleans", "Baton Rouge", "Shreveport"],
  },
  {
    code: "MS",
    name: "Mississippi",
    slug: "mississippi",
    col: 7,
    row: 5,
    cities: ["Jackson", "Gulfport", "Biloxi"],
  },
  {
    code: "AL",
    name: "Alabama",
    slug: "alabama",
    col: 8,
    row: 5,
    cities: ["Birmingham", "Montgomery", "Mobile"],
  },
  {
    code: "GA",
    name: "Georgia",
    slug: "georgia",
    col: 8,
    row: 6,
    cities: ["Atlanta", "Savannah", "Augusta"],
  },
  {
    code: "FL",
    name: "Florida",
    slug: "florida",
    col: 9,
    row: 6,
    cities: ["Miami", "Orlando", "Tampa", "Jacksonville"],
  },
  {
    code: "HI",
    name: "Hawaii",
    slug: "hawaii",
    col: 1,
    row: 6,
    cities: ["Honolulu", "Hilo", "Kailua"],
  },
];

export const slugify = (s: string) =>
  s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");

export const getStateBySlug = (slug: string) => STATES_DATA.find((s) => s.slug === slug);
